import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Box,
  Typography,
  Button,
  FormControlLabel,
  Switch,
  TextField,
  FormGroup,
} from "@mui/material";
import DescriptionIcon from "@mui/icons-material/Description";

export default function DialogCSVSettings(props) {
  let [firstLineAsColumnName, setFirstLineAsColumnName] = useState(null);
  let [removeQuotes, setRemoveQuotes] = useState(null);
  let [separator, setSeparator] = useState(
    localStorage.getItem("CSVSeparator" + props.fileId),
  );

  const firstLineAsColumnNameInitialValue = (fileId) => {
    return localStorage.getItem("CSVFirstLineAsColumnName" + fileId) === "true"
      ? true
      : false;
  };
  const removeQuotesInitialValue = (fileId) => {
    return localStorage.getItem("CSVRemoveQuotes" + fileId) === "true"
      ? true
      : false;
  };

  const handleChangeFirstLineAsColumnNameSwitch = (val) => {
    if (val !== undefined) {
      if (val === "true") {
        setFirstLineAsColumnName(false);
        localStorage.setItem("CSVFirstLineAsColumnName" + props.fileId, false);
      } else {
        setFirstLineAsColumnName(true);
        localStorage.setItem("CSVFirstLineAsColumnName" + props.fileId, true);
      }
    }
  };

  const handleChangeRemoveQuotesSwitch = (val) => {
    if (val !== undefined) {
      if (val === "true") {
        setRemoveQuotes(false);
        localStorage.setItem("CSVRemoveQuotes" + props.fileId, false);
      } else {
        setRemoveQuotes(true);
        localStorage.setItem("CSVRemoveQuotes" + props.fileId, true);
      }
    }
  };

  const handleChangeSeparator = (val) => {
    setSeparator(val);
    localStorage.setItem("CSVSeparator" + props.fileId, val);
  };

  const handleSaveSettings = (fileId) => {
    if (
      firstLineAsColumnName !== "" &&
      removeQuotes !== "" &&
      separator !== ""
    ) {
      props.handleToggleCSVSettings();
      props.handleLoadFile(props.fileId, props.fileName, props.fileContent);
    }
  };

  return (
    <Dialog open={props.open} onClose={() => props.handleToggleCSVSettings()}>
      <DialogTitle>Definições para leitura do CSV</DialogTitle>

      <DialogContent>
        <FormGroup>
          <Box>
            <Typography variant="body2" color="primary">
              <DescriptionIcon fontSize="inherit" /> {props.fileName}
            </Typography>
          </Box>
          <Box mt={2}>
            <FormControlLabel
              control={
                <Switch
                  id="CSVFirstLineAsColumnName"
                  defaultChecked={firstLineAsColumnNameInitialValue(
                    props.fileId,
                  )}
                  onChange={(e) =>
                    handleChangeFirstLineAsColumnNameSwitch(e.target.value)
                  }
                />
              }
              label="Primeira linha como descrição"
              value={
                firstLineAsColumnName === null
                  ? firstLineAsColumnNameInitialValue(props.fileId)
                  : firstLineAsColumnName
              }
            />
          </Box>
          <Box mt={2}>
            <FormControlLabel
              control={
                <Switch
                  id="CSVRemoveQuotes"
                  defaultChecked={removeQuotesInitialValue(props.fileId)}
                  onChange={(e) =>
                    handleChangeRemoveQuotesSwitch(e.target.value)
                  }
                />
              }
              label="Remover &#34;aspas&#34; das extremidades"
              value={
                removeQuotes === null
                  ? removeQuotesInitialValue(props.fileId)
                  : removeQuotes
              }
            />
          </Box>
          <Box mt={2}>
            <TextField
              label="Separador" /* trad */
              variant="outlined"
              defaultValue={localStorage.getItem("CSVSeparator" + props.fileId)}
              sx={{ width: "120px" }}
              onChange={(e) => handleChangeSeparator(e.target.value)}
            />
          </Box>
        </FormGroup>
      </DialogContent>
      <DialogActions>
        {props.children}
        <Button
          variant="contained"
          onClick={() => handleSaveSettings(props.fileId)}
        >
          Fechar{/* trad */}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
